import { Navigate, Route, Routes } from 'react-router-dom';
import DriverTripsPage from '@/pages/driver/DriverTripsPage';
import DriverTripDetailPage from '@/pages/driver/DriverTripDetailPage';
import DriverDeliveryPage from '@/pages/driver/DriverDeliveryPage';

export default function DriverRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="/driver/trips" replace />} />
      <Route path="trips" element={<DriverTripsPage />} />
      <Route path="trip/:tripId" element={<DriverTripDetailPage />} />
      <Route path="deliver/:tripId" element={<DriverDeliveryPage />} />
      <Route path="*" element={<Navigate to="/driver/trips" replace />} />
    </Routes>
  );
}
